<ol class="eui-breadcrumb-items">
    <li class="eui-breadcrumb-item">
        <a routerLink="."
            title="Home"
            aria-label="Home">Home</a>
    </li>
    <li class="eui-breadcrumb-item">
        <a routerLink="."
            title="Section title which can be very big"
            aria-label="Section title which can be very big">Section title which can be very big</a>
    </li>
    <li class="eui-breadcrumb-item">
        <a routerLink="."
            title="Sub-section title which can be very big and automatically truncated based on the size of the page body width"
            aria-label="Sub-section title which can be very big and automatically truncated based on the size of the page body width">Sub-section title which can be very big and automatically truncated based on the size of the page body width</a>
    <li class="eui-breadcrumb-item eui-breadcrumb-item--active" aria-current="page">Page Title of the current page which cannot be clicked</li>
</ol>

<!-- 2DO: Decompose with components?
<eui-breadcrumb-items>
    <eui-breadcrumb-item>...</eui-breadcrumb-item>
    <eui-breadcrumb-item>...</eui-breadcrumb-item>
    <eui-breadcrumb-item>...</eui-breadcrumb-item>
</eui-breadcrumb-items>
-->
